import { Link } from "react-router-dom";
import { IconHome } from "@tabler/icons-react";
import Text from "../UI/Text";
import RevisionTag from "../Dashboard/RevisionTag";
import type { Tenant } from "../../models/tenant";
import type { Property } from "../../models/property";
import styles from "./TenantPropertyCell.module.css";

interface TenantPropertyCellProps {
  tenant: Tenant;
  property?: Property;
}

export default function TenantPropertyCell({
  tenant,
  property,
}: TenantPropertyCellProps) {
  return (
    <div className={styles.tenantInfo}>
      <div className={styles.nameRow}>
        <Link
          to={`/bailleur/tenants/${tenant.id}`}
          className={styles.tenantName}
        >
          <Text as="span" weight="bold">
            {tenant.nom}
          </Text>
        </Link>
        <RevisionTag tenant={tenant} />
      </div>
      {property && (
        <Link
          to={`/bailleur/properties/${property.id}`}
          className={styles.propertyLink}
        >
          <IconHome size={14} stroke={1.5} />
          <Text as="span" variant="deci">
            {property.nom}
          </Text>
        </Link>
      )}
    </div>
  );
}
